<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Update Details"
              bc1="App"
              bc2="Charges"
              bc3="Update"
              path="charges"
          ></Breadcrumb>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Update Details</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Name</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <input
                                  type="text"
                                  v-model="name"
                                  class="form-control"
                                  v-validate="'required'"
                                  name="name"
                                  :class="errorBag.has('name') ? 'is-invalid' : ''"
                                  placeholder="Name"

                              />
                              <small
                                  v-show="errorBag.has('name')"
                                  class="invalid-feedback"
                              >{{ "*" + errorBag.first("name") }}</small
                              >

                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Select Charges Type</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <select class="form-control" v-validate="'required'"
                                      :class="
                                  errorBag.has('type') ? 'is-invalid' : ''
                                "
                                      v-model="type">
                                <option value="">Select Type</option>
                                <option :value="item" v-for="(item) in chargeTypeOption">
                                  {{item.name}}
                                </option>
                              </select>
                              <small
                                  v-show="errorBag.has('type')"
                                  class="invalid-feedback"
                              >{{ "*" + errorBag.first("type") }}</small>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 d-flex mt-3 mb-3  justify-content-center" v-if="loader">
                        <div class="spinner-border text-primary"></div>
                      </div>
                      <div v-show="type.alias.toUpperCase() == 'CARD'" class="col-12" v-for="(item) in chargeDetailTypeOptionForCard">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Select {{item.name}}</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <select class="form-control" v-model="selectedCardMeta[item.id]">
                                <option value="undefined">Select</option>
                                <option :value="charge.id" v-for="(charge) in chargesTypeList.filter((i) => i.type_id == item.id)">
                                  {{charge.title}}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-9 offset-sm-3 d-flex">
                        <button
                            type="button"
                            class="btn btn-primary mr-1 d-flex"
                            @click="sendCall"
                            :disabled="loading"
                        >
                          <Loader :loading="loading" :size="size"></Loader>
                          Save
                        </button>
                        <button
                            type="button"
                            class="btn btn-gradient-secondary"
                            @click="$router.push({ name: 'charges' })"
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
export default {

  mounted() {
    this.getChargesTypes()
    this.getChargesList()
    let chargesUpdateData = this.$store.getters.getByKey("chargesUpdate");
    this.index = chargesUpdateData.index;
    this.id = chargesUpdateData.row.id;

    this.name = chargesUpdateData.row.name
  },
  data() {
    return {
      name: "",
      type: "",
      loading: false,
      size: "10px",
      chargeTypeOption: [],
      chargeDetailTypeOptionForCard: [],
      chargeTypeDetailOptions: [],
      selectedCardMeta:{},
      chargesTypeList:[],
      loader:false
    };
  },
  methods: {
    getCharges(chargeId){
      this.makeRequest("post", "v1/get-charges", {chargeId: chargeId}, {}, false,true,[205]).then(
          callResponse => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                let data = []
                data = callResponse.response.data.data;
                if(data){
                  let selectedCardMeta = {}
                  this.chargeDetailTypeOptionForCard.map((item)=>{
                    let ob  = data.filter(i => i.card_meta_data_type_alias == item.alias)
                    if(ob.length > 0){
                      selectedCardMeta[item.id] = ob[0].card_meta_data_id
                    }
                  })
                  this.selectedCardMeta = {
                    ...selectedCardMeta
                  }
                }

              }
            }
          }
      );
    },
    getChargesTypes(param = 'chargeTypes'){
      this.loader = true
      this.makeRequest("post", "v1/get-charges-types-data", {[param]: 1}, {}, false,true,[205]).then(
          callResponse => {
            this.loader = false
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                let data = []
                data = callResponse.response.data.data;
                if(data){
                  let chargesUpdateData = this.$store.getters.getByKey("chargesUpdate");
                  if(param == 'chargeTypes'){
                    this.chargeTypeOption = data.chargeTypes
                    this.type =  this.chargeTypeOption.filter(i => i.id == chargesUpdateData.row.type_id)[0]
                  }else if(param == 'cardMetaDataTypes'){
                    this.chargeDetailTypeOptionForCard = data.cardMetaDataTypes
                    this.getCharges(this.id)
                  }
                }

              }
            }
          }
      );
    },
    getChargesList(){
      this.makeRequest("post", "v1/get-card-meta-data", {status: 1}, {}, false,true,[205]).then(
          callResponse => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                let data = []
                data = callResponse.response.data.data;
                if(data){
                  this.chargesTypeList = data
                }

              }
            }
          }
      );
    },
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          let data = {
            id : this.id,
            name : this.name,
            typeId : this.type.id,

          }

          if(this.type.alias.toUpperCase() == "CARD"){
            data.cardCharges = JSON.stringify(this.selectedCardMeta)
          }


          this.makeRequest("post", "v1/update-charge", data).then(callResponse => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                this.loading = false;
                if (callResponse.response.data.data) {
                  let responseData = callResponse.response.data.data;
                  let storeData = this.$store.getters.getByKey("charges");
                  if (storeData.firstPageData) {
                    if (typeof storeData.firstPageData.data != "undefined") {
                      storeData.firstPageData.data.unshift(responseData);
                      storeData.firstPageData.pagination.total = storeData.firstPageData.pagination.total + 1
                      if(storeData.firstPageData.pagination.perPage < storeData.firstPageData.pagination.total){
                        storeData.firstPageData.data.pop();
                      }
                      storeData.key = "charges";
                      delete storeData.otherPageData;
                      this.$store.dispatch("set", storeData);
                    }
                  }
                  this.$router.push({
                    name: "charges",
                    // params: { add: true }
                  });
                }
              } else {
                this.loading = false;
              }
            }
          });
        }
      });
    }
  },
  watch:{
    type(val){
      // this.name=""
      this.chargeTypeDetailOptions = this.chargeTypeOption[val]
      if(typeof val != "undefined" && val.alias.toUpperCase() == "CARD"){
        if(this.chargeDetailTypeOptionForCard.length == 0){
          this.getChargesTypes('cardMetaDataTypes')
        }
      }
    },
  }
};
</script>

